import { useMutation } from "react-query";
import { toast } from "react-toastify";

import { updateGeomBinOrder } from "api/data";

import { EntityKind } from "models/entityKind";

import { useGetCategoryList } from "components/groupBy/hooks/useGetCategoryList";

interface UpdateGeomBinOrderPayload {
  groupName: string;
  items: Array<{ id: string; withinSubgroupOrder: number }>;
  projectId?: string;
  isProjectDefined?: boolean;
}

const useGeomBinOrderMutation = (projectId?: string) => {
  const { getCategoryListWithUnit } = useGetCategoryList();
  const mutation = useMutation<unknown, Error, UpdateGeomBinOrderPayload>(
    async (data) => {
      const {
        groupName,
        items,
        projectId: dataProjectId,
        isProjectDefined: dataIsProjectDefined
      } = data;
      const result = await updateGeomBinOrder(
        items,
        groupName,
        dataProjectId || projectId,
        dataIsProjectDefined
      );
      return result;
    },
    {
      onSuccess: () => {
        // geom bins currently only exist for Wells
        getCategoryListWithUnit(EntityKind.Well);
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onError: (err: any) => {
        const errorMessage =
          typeof err.response?.data === "string"
            ? err.response.data
            : err.response?.data?.message ||
              err.response?.statusText ||
              "Error could not update order";

        toast.error(errorMessage);
      }
    }
  );

  return mutation;
};

export default useGeomBinOrderMutation;
